<template>
  <div class="container">
    <div class="agency-subscription-checkout my-5 col-xl-7">
      <div v-if="subscription && subscription.agency && subscription.agency.domains && subscription.agency.domains.length && subscription.agency.domains[0].logo_src" class="text-center">
        <img :src="subscription.agency.domains[0].logo_src" alt="Agency Logo" class="mb-3" />
      </div>
      <div v-if="subscription">
        <h4 class="mb-2">{{ subscription.name }}</h4>
        <p class="text-muted mb-4">{{ subscription.description }}</p>
      </div>
      <ValidationObserver ref="checkoutForm" v-slot="{ handleSubmit, invalid, touched }">
        <b-form class="mx-auto authentication-form text-left" @submit.prevent="handleSubmit(submitForm)">
          <div class="row">
            <div class="col-md-6 mb-1">
              <TextInput
                  v-model="firstName"
                  label="First Name"
                  icon="user"
                  placeholder="First name"
                  name="first_name"
                  autocomplete="given-name"
                  required
              />
            </div>
            <div class="col-md-6 mb-1">
              <TextInput
                  v-model="lastName"
                  label="Last Name"
                  placeholder="Last name"
                  name="last_name"
                  autocomplete="family-name"
                  required
              />
            </div>
          </div>
          <div class="mb-4">
            <TextInput
                v-model="email"
                label="Email Address"
                icon="mail"
                placeholder="Enter email"
                name="email"
                type="email"
                autocomplete="email"
                required
            />
          </div>
          <b-form-group class="mt-3">
            <b-button
                variant="primary"
                class="btn-dark-blue w-100 p-2"
                :disabled="loading || (invalid && touched)"
                type="submit"
            >
              <b-spinner v-if="loading" small />
              <span v-else>Continue to Payment</span>
            </b-button>
          </b-form-group>
        </b-form>
      </ValidationObserver>
      <div v-if="error" class="text-danger mt-2">{{ error }}</div>
    </div>
  </div>
</template>

<script>


export default {
  name: 'AgencySubscriptionCheckout',
  components: {},
  data() {
    return {
      firstName: '',
      lastName: '',
      email: '',
      loading: false,
      error: '',
      subscription: null,
      subscriptionId: null,
    };
  },
  mounted() {
    this.subscriptionId = this.$route.params.id;
    this.$store.dispatch('agency/returnCheckout', this.subscriptionId)
      .then(res => {
        this.subscription = res;
      })
      .catch(() => {
        this.subscription = null;
      });
  },
  methods: {
    submitForm() {
      this.loading = true;
      this.error = '';
      // Send user details to backend and get Stripe checkout URL
      this.$store.dispatch('agency/returnCheckoutLink', {
        first_name: this.firstName,
        last_name: this.lastName,
        email: this.email,
        subscription_id: this.subscriptionId,
      }).then((response) => {
        if (response && response.session.url) {
          if(response.access_token){
            localStorage.setItem('access_token', response.access_token)
          }
          window.location.href = response.session.url;
        } else {
          this.error = 'Unable to start checkout session.';
          this.loading = false;
        }
      }).catch((err) => {
        this.loading = false;
        if (err.response && err.response.data && err.response.data.errors) {
          this.$refs.checkoutForm.setErrors(err.response.data.errors);
        }
      });
    },
  },
};
</script>
<style lang="scss">
  .agency-subscriptions-checkout{
    input.is-invalid {
      border-top-right-radius: 0.3rem !important;
      border-bottom-right-radius: 0.3rem !important;
    }
  }
</style>
<style scoped>

.agency-subscription-checkout {

  margin: 40px auto;
  padding: 30px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
}
.form-control-label {
  font-weight: 500;
  margin-bottom: 0.3em;
  color: #555;
}
.input-group-text {
  background: #fff;
  border: none;
  color: #888;
  font-size: 1.1em;
}
.authentication-form .form-control {
  min-width: 0;
}
.agency-logo {
  max-width: 120px;
  max-height: 60px;
  margin-bottom: 1rem;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
</style>
